import { Experiment } from "@/http/api-types";

export type ExperimentStatus = "scheduled" | "active" | "waiting_for_outcome" | "concluded";

export function getExperimentStatus(experiment: Experiment): ExperimentStatus {
  const now = new Date();
  const startDate = experiment.start_date ? new Date(experiment.start_date) : null;
  const endDate = experiment.end_date ? new Date(experiment.end_date) : null;

  if (experiment.outcome) {
    return "concluded";
  }

  if (startDate && startDate > now) {
    return "scheduled";
  }

  if (endDate && endDate < now) {
    return "waiting_for_outcome";
  }

  return "active";
}

export function getExperimentStatusLabel(status: ExperimentStatus): string {
  switch (status) {
    case "scheduled":
      return "Scheduled";
    case "active":
      return "Active";
    case "waiting_for_outcome":
      return "Waiting for Outcome";
    case "concluded":
      return "Concluded";
  }
}

export function getExperimentStatusVariant(status: ExperimentStatus): "scheduled" | "active" | "concluded" | "outline" {
  switch (status) {
    case "scheduled":
      return "scheduled";
    case "active":
      return "active";
    case "waiting_for_outcome":
      return "outline";
    case "concluded":
      return "concluded";
  }
}
